const privacy = {
  'privacy.page.backToTop': 'ページの先頭へ戻る',
  'privacy.page.lastUpdated': '最終更新: 2026年6月13日',
  'privacy.page.homeLink': 'ホーム',
  'privacy.page.currentPage': 'プライバシーポリシー',

  'privacy.hero.homeLink': 'ホーム',
  'privacy.hero.currentPage': 'プライバシーポリシー',
  'privacy.hero.title': 'プライバシーポリシー',
  'privacy.hero.titleEn': 'PRIVACY POLICY',
  'privacy.hero.lead': '一般社団法人全日本執事協会（以下「当協会」）は、日本執事アカデミーの運営にあたり取得する個人情報の取扱いについて、以下の方針を定め、適切に管理いたします。',
  'privacy.hero.imgAlt': '施錠された書類保管庫と個人情報保護を象徴する静物',

  'privacy.jsonld.breadcrumb1': 'ホーム',
  'privacy.jsonld.breadcrumb2': 'プライバシーポリシー',
  'privacy.jsonld.orgName': '日本執事アカデミー',
  'privacy.jsonld.parentOrg': '一般社団法人全日本執事協会',

  'privacy.toc.title': '目次',
  'privacy.toc.subtitleEn': 'CONTENTS',
  'privacy.article.prefix': '第',
  'privacy.article.suffix': '条',

  'privacy.related.title': '関連ページ',
  'privacy.related.0.title': '利用規約',
  'privacy.related.0.desc': '本サイトの利用条件',
  'privacy.related.1.title': '特定商取引法に基づく表記',
  'privacy.related.1.desc': '法定情報の開示',
  'privacy.related.2.title': 'お問い合わせ',
  'privacy.related.2.desc': 'ご質問・ご相談はこちら',
  'privacy.related.viewMore': '見る',

  // PrivacyContent UI chrome
  'privacy.toc.heading': '目次',
  'privacy.content.preamble': '一般社団法人全日本執事協会（以下「当協会」）は、日本執事アカデミーの運営にあたり取得する個人情報について、個人情報の保護に関する法律その他の関係法令を遵守し、以下の方針に基づき適切に取り扱います。本ポリシーは、当協会が取得するすべての個人情報に適用されます。',
  'privacy.content.enactDate': '制定日',
  'privacy.content.enactDateValue': '準備中',
  'privacy.content.lastRevised': '最終改定日',
  'privacy.content.lastRevisedValue': '2026年6月13日',
  'privacy.content.amendNotice': '本プライバシーポリシーは予告なく改定する場合があります。',

  // Article titles
  'privacy.a.01.title': '事業者情報',
  'privacy.a.02.title': '取得する個人情報',
  'privacy.a.03.title': '利用目的',
  'privacy.a.04.title': '第三者提供',
  'privacy.a.05.title': '外部委託',
  'privacy.a.06.title': '安全管理措置',
  'privacy.a.07.title': '開示・訂正・削除等の請求',
  'privacy.a.08.title': 'Cookie（クッキー）およびアクセス解析の利用',
  'privacy.a.09.title': 'お問い合わせ窓口',
  'privacy.a.10.title': '改定について',

  'privacy.a.01.p.0': '当協会は、日本執事アカデミーを運営する一般社団法人です。当サイトおよび当アカデミーに関する個人情報の取扱いについては、当協会が責任を負います。',
  'privacy.a.01.p.1': '名称：一般社団法人 全日本執事協会',
  'privacy.a.01.p.2': '所在地：東京都江東区青海2-7-4',
  'privacy.a.01.p.3': '電話番号：03-6824-4086（平日 10:00〜17:00）',
  'privacy.a.01.p.4': 'メールアドレス：info@butler-academy.jp',

  'privacy.a.02.p.0': '当協会は、以下の場面において、お客様の個人情報を取得いたします。',
  'privacy.a.02.p.1': '資料請求時：氏名、ふりがな、メールアドレス、電話番号（任意）、ご興味のあるコース（任意）',
  'privacy.a.02.p.2': '個別相談お申込み時：氏名、ふりがな、メールアドレス、電話番号、ご相談内容、ご希望の日時',
  'privacy.a.02.p.3': '各種お申込み・お問い合わせ時：氏名、ふりがな、メールアドレス、電話番号、その他お客様が入力された情報',
  'privacy.a.02.p.4': '法人研修のお問い合わせ時：企業名、ご担当者名、部署名、メールアドレス、電話番号、ご相談内容',

  'privacy.a.03.p.0': '取得した個人情報は、以下の目的に限り利用いたします。',
  'privacy.a.03.p.1': '（1）お申込み・お問い合わせへの対応',
  'privacy.a.03.p.2': '（2）資料の送付（PDF）',
  'privacy.a.03.p.3': '（3）講座・サービスに関するご案内とご連絡',
  'privacy.a.03.p.4': '（4）サービスの品質向上のための分析',
  'privacy.a.03.p.5': '（5）法令に基づく対応',
  'privacy.a.03.p.6': '上記の目的を超えて個人情報を利用する場合は、あらかじめご本人の同意を得るものといたします。',

  'privacy.a.04.p.0': '当協会は、以下のいずれかに該当する場合を除き、ご本人の同意なく個人情報を第三者に提供いたしません。',
  'privacy.a.04.p.1': '（1）法令に基づく場合',
  'privacy.a.04.p.2': '（2）人の生命、身体または財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき',
  'privacy.a.04.p.3': '（3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき',
  'privacy.a.04.p.4': '（4）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき',

  'privacy.a.05.p.0': '当協会は、利用目的の達成に必要な範囲内で、個人情報の取扱いの全部または一部を外部に委託する場合があります。',
  'privacy.a.05.p.1': '委託にあたっては、個人情報の安全管理が図られるよう、委託先に対する必要かつ適切な監督を行います。',
  'privacy.a.05.p.2': '具体的には、システムの保守・運用業務、メール配信業務等において、外部事業者に委託することがございます。',

  'privacy.a.06.p.0': '当協会は、個人情報の漏えい、滅失または毀損の防止その他の個人情報の安全管理のために、必要かつ適切な措置を講じます。',
  'privacy.a.06.p.1': '具体的には、アクセス制限、ウイルス対策、情報の暗号化、従業者に対する教育・監督等の措置を実施しております。',
  'privacy.a.06.p.2': 'ただし、インターネットの性質上、情報の完全な安全性を保証するものではありません。当協会は、合理的な範囲でセキュリティの向上に努めてまいります。',

  'privacy.a.07.p.0': 'ご本人から、当協会が保有する自己の個人データについて、開示、訂正、追加、削除、利用停止、消去または第三者提供の停止（以下「開示等」といいます）のご請求があった場合、法令に従い、ご本人確認のうえ、合理的な期間内に対応いたします。',
  'privacy.a.07.p.1': '開示等のご請求は、下記のお問い合わせ窓口までご連絡ください。',
  'privacy.a.07.p.2': 'なお、開示請求にあたっては、実費相当額の手数料を申し受ける場合がございます。あらかじめご了承ください。',

  'privacy.a.08.p.0': '当サイトでは、アクセス解析およびサービス向上のため、CookieやGoogle Analytics等のアクセス解析ツールを利用する場合があります。',
  'privacy.a.08.p.1': 'Cookieは、お客様のブラウザに保存される小さなテキストファイルであり、サイトの利用状況を把握するために用いられます。',
  'privacy.a.08.p.2': 'お客様は、ブラウザの設定によりCookieの受け入れを拒否したり、削除したりすることができます。ただし、Cookieを無効化した場合、当サイトの一部機能が正しく動作しない可能性がございます。',

  'privacy.a.09.p.0': '本プライバシーポリシーに関するご質問や、個人情報の取扱いに関するお問い合わせは、下記までご連絡ください。',
  'privacy.a.09.p.1': '一般社団法人 全日本執事協会 個人情報保護担当',
  'privacy.a.09.p.2': 'メールアドレス：info@butler-academy.jp',
  'privacy.a.09.p.3': '電話番号：03-6824-4086（平日 10:00〜17:00）',
  'privacy.a.09.p.4': '受付後、内容を確認のうえ、担当者よりご連絡いたします。',

  'privacy.a.10.p.0': '当協会は、法令の改正や事業内容の変更等に伴い、本プライバシーポリシーを予告なく改定する場合があります。',
  'privacy.a.10.p.1': '重要な変更がある場合は、当サイト上でお知らせいたします。',
  'privacy.a.10.p.2': '改定後のプライバシーポリシーは、当サイトに掲載した時点で効力を生じるものといたします。',
  'privacy.a.10.p.3': '制定日：準備中',
};

export default privacy;
